import Model from "../Model";

class VideowallGroup extends Model{

    buildUrl ({ param }) {
        return ['/videowall', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new VideowallGroup;